import { createUseStyles } from 'react-jss';

export const useAssetIconStyles = createUseStyles({
    root: {
        height: 32,
        width: 32,
    },
});
